// extracted by mini-css-extract-plugin
module.exports = {"layout":"BodySubReviewPopup_layout_32IKa","layoutMobile":"BodySubReviewPopup_layoutMobile_2UONt"};